import { Component, EventEmitter, Injector, Input, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatRow } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ResourceType } from 'src/app/common/enumerations/enumerations';
import { utils } from 'src/app/modules/libs/utils';
import { Resource } from '../../beamline-catalog/resource/resources';
import { ResourcesService } from '../../beamline-catalog/resource/resources.service';

@Component({
  selector: 'sce-list-side',
  templateUrl: './sce-list-side.component.html',
  styleUrls: ['./sce-list-side.component.scss']
})
export class SceListSideComponent extends BaseComponent {

  @Input() filter?: string | null;
  //@Output() loading = new EventEmitter<boolean>();

  displayedColumns: string[] = [
    'name',
    'type'
  ];
  dataSource = new MatTableDataSource<Resource>();

  @Output() rowSelected = new EventEmitter<any>();
  @Output() rowsFiltered = new EventEmitter<Resource[]>();

  @ViewChildren('matrow', { read: ViewContainerRef }) rows?: QueryList<ViewContainerRef>;
  @ViewChildren('matrow') datarows?: QueryList<MatRow>;

  allowNew = false;
  disabled = false;
  maxHeight!: string;

  resource?: Resource | null;
  resources?: Resource[];
  resourcesFiltered?: Resource[];
  resources$!: Observable<Resource[]>;
  resourcesSubs!: Subscription;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    protected override injector: Injector,
    private service: ResourcesService
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.applyFilter();
    }
  }

  override ngOnDestroy(): void {
    this.resourcesSubs?.unsubscribe();
  }

  ngOnInit(): void {
    this.loadResources();
  }

  loadResources() {
    this.resources$ = this.store.select(state => state.Resources.data);
    this.resourcesSubs = this.resources$.subscribe(data => {
      if (data?.length) {
        this.resources = data.filter(r => r.type == ResourceType.Beamline);
        this.createDataSource();
      }
    });
  }

  createDataSource() {
    this.resourcesFiltered = this.resources?.filter(r => this.hasSCE(r))
      .filter(r => this.filter ? (r.displayName?.includes(this.filter.toLowerCase()) || r.name?.includes(this.filter.toLowerCase())) : true);

    this.resourcesFiltered?.map(r => {
      r.displayName = r.name;
      r.sceLinks = this.utils.JSONparse(r.sceLink);
    });
    this.resourcesFiltered = this.resourcesFiltered?.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers((a.type?.toString() ?? '0') + a.displayName, (b.type?.toString() ?? '0') + b.displayName));
    this.dataSource = new MatTableDataSource(this.resourcesFiltered);
    this.setSortingAccessor();
    this.rowsFiltered.emit(this.resourcesFiltered);
  }

  setSortingAccessor() {
    // Define the sorting accessor
    this.dataSource.sortingDataAccessor = (element, property) => {
      switch (property) {
        case 'name':
          return element.displayName;
        case 'type':
          return element.resourceType?.name;
        default:
          return (element as any)[property]; // Fallback to the default property
      }
    };
    this.setSort<Resource>(this.dataSource, this.sort);
  }

  hasSCE(r: Resource) {
    return r.sceLink?.length;
  }

  rowUnselected() {
    this.resource = null;
    this.rowSelected.emit(null);
  }

  rowClicked(row: Resource) {
    if (this.resource?.id == row.id) {
      this.rowUnselected();
      //this.loading.emit(false);
    }
    else {
      this.getValues(row);
    }
  }

  async getValues(row: Resource) {
    if (row?.id) {
      this.resource = row;
      this.rowSelected.emit(this.resource);
    }
  }
  //#endregion LOAD

  //#region ADD

  unselect() {

  }

  //#endregion

  //#region FILTERS

  applyFilter() {
    this.createDataSource();
    this.dataSource.filter = this.filter?.trim().toLowerCase() ?? '';
  }

  changeClosed() {
    this.applyFilter();
  }

  async refresh() {

  }

  //#endregion

  // #region TableScroll
  showElement(index: number, height: number) {
    const indexstr = index.toString();
    const row = this.rows?.find(
      (r) => r.element.nativeElement.getAttribute('position') === indexstr
    );
    if (row) {
      const rect = row.element.nativeElement.getBoundingClientRect();
      if (rect.y <= 0 || rect.y + rect.height > height) {
        row.element.nativeElement.scrollIntoView(false, {
          behavior: 'instant',
        });
      }
      return;
    }
    console.log('not found');
  }

  getPosition(row: any): number {
    const i = this.dataSource.data.findIndex((r) => {
      return r.id === row.id;
    });
    return i;
  }

  formatLocationNames(locationNames: string) {
    if (locationNames) {
      return utils.replaceAll(locationNames, ',', ', ');
    }
    return '';
  }

}